import React from "react";
import { useDispatch } from 'react-redux';
import { setBookingId } from "../redux/data.js";

const PaymentResult = ({ id }) => {
  const dispatch = useDispatch();

  const tryAgain = () => {
    dispatch(setBookingId('select-vehicle'))
  }
  return (
    <div className="p-10 border-b-2 border-gray-200">
      <div className="flex flex-col items-center text-center">
        <div className="text-red-500 text-lg font-bold uppercase">Woops! Something went wrong with your payment</div>
        <button
          className="mt-4 bg-primary hover:bg-primary/80 text-white font-semibold p-2 rounded-lg"
          onClick={tryAgain}
        >
          Try to book again
        </button>
      </div>
    </div>
  );
};

export default PaymentResult;
